<div *ngIf="vm$ | async as vm" class="is-flex gap-8">

  <ng-container *ngFor="let dataset of vm.datasets; let i = index">

    <section *ngIf="showLabel(dataset, vm)"
      (click)="toggleDatasetVisibility(i, vm.datasets.length)"
      class="dataset is-flex gap-8 is-align-center text-12 text-grey-70 is-family-medium"
      [class.is-cursor-pointer]="vm.datasets.length > 1"
      [class.bg-grey-hover-10]="vm.datasets.length > 1"
      [style.opacity]="dataset.hidden ? 0.3 : 1">

      <div class="legend"
        [style.backgroundColor]="'var(' + dataset.color + ')'"></div>

      <div class="is-flex is-align-center">
        <app-text>
          {{ dataset.label | AsyncLang | async}}
        </app-text>
        <ng-container *ngIf="showTotals(vm.card.graphType)">
          <app-text>&nbsp;:&nbsp;</app-text>
          <app-text>{{ vm.totals[i] | toDisplayValue : dataset.measureType }}</app-text>
          <app-text>&nbsp;</app-text>
          <app-text unit [measureType]="dataset.measureType"></app-text>
        </ng-container>
      </div>
    </section>

  </ng-container>

</div>